import React from 'react'
import '../../css/Common.css'
import './css/TermOfUse.css'

const TermOfUse = () => {
  return (
        <div class="main-container term-of-use-container">
            <div class="term-of-use">
                <h1>利用規約</h1>
                <p>本サービスの利用者（以下「ユーザー」といいます）は、予め本規約に同意した上で、Insight Note を利用するものとします。</p>

                <h2>本規約の適用範囲</h2>
                <p>本規約は、別段の定めがない限り、Insight Note を利用する全てのユーザーに対して適用されるものとし、ユーザーは、本規約の内容を確認の上、これを遵守するものとします。</p>
                <ol>
                <li>ユーザーは、Insight Note の利用について、その全部あるいは一部を問わず、当社の許諾なく、営業活動その他の営利を目的とした行為又はそれに準ずる行為やそのための準備行為を目的として、利用またはアクセス（以下「目的外利用等」といいます）してはならないものとします。ユーザーの利用またはアクセスが目的外利用等と疑われる場合、当社はユーザーのInsight Note へのアクセスを一時停止または停止する場合がございます。</li>
                <li>ユーザーが前項に反する行為によって利益を得た場合､当社はその利益相当額を請求できる権利を有するものとします｡</li>
                </ol>

                <h2>免責事項について</h2>
                <p>１ 当社は、Insight Note 上においてユーザーが利用可能なデータその他一切のコンテンツ（以下「本コンテンツ」といいます）およびサービス自体について、その安全性、信頼性、完全性、正確性、最新性、網羅性、耐久性、有用性、冪等性、第三者の権利を侵害していないこと、セキュリティ上の欠陥がないこと等について、いかなる保証もいたしません。本コンテンツおよびInsight Note については、ユーザーご自身の判断と責任においてご利用ください。</p>
                <p>２ 当社は、Insight Note からリンクされた第三者が運営するサイトに関して、いかなる保証もいたしません。ユーザーのご判断でご利用ください。</p>
                <p>３ 機械的な手法を用いてデータを収集しておりますが、データに誤りが含まれる可能性があります。その安全性、信頼性、完全性、正確性、最新性、網羅性、耐久性、有用性、冪等性、第三者の権利を侵害していないこと、セキュリティ上の欠陥がないこと等について、いかなる保証もいたしません。</p>
                <p>４ 当社のサービスでは生成AIを利用しておりますが、その回答についていかなる保証も行いません。その安全性、信頼性、完全性、正確性、最新性、網羅性、耐久性、有用性、冪等性、第三者の権利を侵害していないこと、セキュリティ上の欠陥がないこと等について、いかなる保証もいたしません。</p>

                <h2>アクセスデータ利用について</h2>
                <ol>
                <li><strong>アクセスデータの内容</strong><br />
                お客様が当社のWEBサイトを閲覧された際は、次のアクセスデータを収集し、後記3のとおり外部に送信いたします。<br />
                - 閲覧された日時<br />
                - 閲覧されたURL<br />
                - 質問の内容<br />
                - コンピュータ端末のIPアドレス<br />
                - オペレーティングシステム<br />
                - ブラウザの種類<br />
                - リファラー情報（お客様が当社のWEBサイトを閲覧される一つ前のURLデータ）</li>
                <li><strong>アクセスデータの利用目的</strong><br />
                WEBサイトの動作に不可欠なデータ利用／お客様の機能性のためのデータ利用<br />
                分析のためのデータ利用<br />
                当社が収集した上記データは、お客様に対してより良いサービスをご提供するためにも利用いたします。<br />
                具体的には、閲覧状況の分析、当社が提携する第三者企業のサービスとの連携、アンケート調査などに利用いたします。</li>
                </ol>

                <h2>禁止行為について</h2>
                <p>１ ユーザーがInsight Note を利用するに際して、次の行為を行うことを禁止します。<br />
                ［1］法令上または本規約若しくはガイドライン上特に認められている場合を除き、Insight Note において提供される情報を当社の事前の同意なく、複写、若しくはその他の方法により再生、複製、送付、譲渡、頒布、配布、転売、又はこれらの目的で使用するために保管すること<br />
                ［2］本規約に違反すること<br />
                ［3］公序良俗に反すること<br />
                ［4］違法行為・犯罪的行為・重大な危険行為に結びつくことまたはこれらを助長すること<br />
                ［5］当社、他のユーザー又は第三者の知的財産権（著作権、意匠権、実用新案権、商標権、特許権、ノウハウが含まれますがこれに限定されません）を侵害すること<br />
                ［6］他のユーザー又は第三者の権利又は利益を違法に侵害し、又はそのおそれがあること<br />
                ［7］Insight Note の運営を妨げることもしくは他のユーザーのInsight Note の利用を妨げること（たとえば以下に例示することを含みますがこれらに限りません）<br />
                ・ 当社の事前の同意なく、Insight Note に対してツールやプログラムを利用するなどの自動化または機械化されたアクセスを行うこと（スクレイピングを含みますがこれに限りません）またはそのおそれがあること。<br />
                ・ 他のユーザーのIDを用いてInsight Note にログインすることまたは他のユーザーになりすまして（IPアドレスを偽るなどの行為を含みますがこれに限りません）Insight Note を利用することまたはその  おそれがあること<br />
                ・ 当社または第三者のサーバコンピュータやネットワーク機器に不正にアクセスを行うことまたはそのおそれがあること<br />
                ・ Insight Note のシステムもしくはネットワークの脆弱性を探索することまたはその目的でInsight Note にアクセスを行うこと<br />
                ・ Insight Note のセキュリティ、ユーザー認証方法を侵害または回避することまたはその目的でInsight Note にアクセスを行うこと<br />
                ・ ウイルス等の有害なコンピュータプログラム等を送信することまたはそのおそれがあること<br />
                ・ 通常利用の範囲を超えた通信アクセスを行うなど、当社または第三者のサーバコンピュータやネットワーク機器に負荷を与えたり、サービス運営に支障をきたし、もしくは他のユー ザーのInsight Note の利用を妨げることまたはそれらのおそれがあること<br />
                ［8］当社の信用を毀損することまたはそのおそれがあることその他Insight Note の目的に照らして当社が不適切と判断すること</p>
            </div>
        </div>
  )
}

export default TermOfUse